import React, { useState, useRef, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';

const TypographyWithTooltip = ({ children, tooltipProps, showTimeserieToolTip=false, ...textProps }) => {
  const [isOverflowing, setIsOverflowing] = useState(false);
  const childRef = useRef(null);

  const checkDimensions = useCallback(() => {
    if (childRef.current && !showTimeserieToolTip) {
      const { scrollWidth, offsetWidth } = childRef.current;
      setIsOverflowing(scrollWidth > offsetWidth);
    }
    else {
      setIsOverflowing(true);
    }
  }, []);

  useEffect(() => {
    checkDimensions();
  });

  useEffect(() => {
    const debouncedCheckDimensions = debounce(checkDimensions, 300);
    window.addEventListener('resize', debouncedCheckDimensions);

    return () => window.removeEventListener('resize', debouncedCheckDimensions);
  }, [checkDimensions]);

  const text = React.useMemo(
    () => (
      <Typography ref={childRef} noWrap {...textProps}>
        {children}
      </Typography>
    ),
    [textProps, children]
  );

  return isOverflowing ? (
    <Tooltip title={showTimeserieToolTip ? tooltipProps.value : children} {...tooltipProps}>
      {text} 
    </Tooltip>
  ) : (
    text
  );
};

TypographyWithTooltip.propTypes = {
  children: PropTypes.string.isRequired,
  tooltipProps: PropTypes.shape({})
};

TypographyWithTooltip.defaultProps = {
  tooltipProps: null
};

export default TypographyWithTooltip;
